/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link, Typography, typography } from '@coursera/cds-core';
import { LinkIcon } from '@coursera/cds-icons';

type Props = React.HTMLAttributes<HTMLHeadingElement>;

const styles = {
  heading: css`
    color: black;

    a {
      color: black !important;

      span {
        display: none;
      }

      &:hover {
        color: black !important;

        span {
          display: inline;
        }
      }
    }
  `,
};

const AnchorHeading = ({ id, children }: Props) => (
  <Typography component="h2" variant="h1semibold" id={id} css={styles.heading}>
    <Link href={`#${id}`} variant="quiet" css={typography.h1semibold} icon={<LinkIcon />} iconPosition="after">
      {children}
    </Link>
  </Typography>
);

export default AnchorHeading;
